import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import CrisisPopupInput from "../../../components/CrisisPopupInput/CrisisPopupInput";
import HeaderBread from "../../../components/HeaderBread";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import { getCrisisPopup } from "../../../utils/ApiCalls/CrisisPopup";

const EditCrisisPopup = () => {
  const params = useParams();
  const [crisispopup, setcrisispopup] = useState({});
  const [, dispatch] = useDataLayerValue();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "crisispopup",
     route: "/website/cms/crisis-page/crisis-popup"
    },
    {
      title: "Edit crisispopup",
      route: "/website/cms/news-letter/edit",
    },
  ];
  useEffect(() => {
    getData(params?.id);
  }, [params]);

  const getData = async (value) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getCrisisPopup({ id: value });

    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.count === 1) {
      setcrisispopup(data.data[0]);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  return (
    <Layout type={"update_per"} module_data={"Crisis Popup"}>
      <CustomHeaderTitle title={"Edit Crisis Popup"} />
      <HeaderBread
        navigation={navigation}
        title={"Edit Crisis Popup"}
      ></HeaderBread>
      {crisispopup && <CrisisPopupInput crisispopup={crisispopup} />}
    </Layout>
  );
};

export default EditCrisisPopup;
